import { inject } from '@angular/core';
import { CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { IsLoggedInGuard } from '@app/guards/is-logged-in/is-logged-in.guard';

export const isLoggedInGuard: CanActivateFn = (_, state: RouterStateSnapshot) => inject(IsLoggedInGuard).isLoggedIn(state);
